const SENSITIVE_KEYS = new Set([
  'password',
  'pass',
  'pwd',
  'token',
  'accessToken',
  'refreshToken',
  'authorization',
  'cookie',
  'set-cookie',
  'secret',
  'apiKey',
]);

export function deepRedact<T>(value: T): T {
  if (value === null || value === undefined) return value;
  if (Array.isArray(value)) return value.map(deepRedact) as T;

  if (typeof value === 'object') {
    const obj = value as Record<string, unknown>;
    const out: Record<string, unknown> = {};

    for (const [k, v] of Object.entries(obj)) {
      out[k] = SENSITIVE_KEYS.has(k) || SENSITIVE_KEYS.has(k.toLowerCase()) ? '[Filtered]' : deepRedact(v);
    }

    return out as T;
  }

  return value;
}

function tryParseJson(input: unknown) {
  if (typeof input !== 'string') return input;
  try {
    return JSON.parse(input);
  } catch {
    return input;
  }
}

export function sanitizeAxiosError(err: any) {
  const config = err?.config;
  const response = err?.response;

  const requestData = deepRedact(tryParseJson(config?.data));
  const responseData = deepRedact(response?.data);

  return {
    name: err?.name,
    message: err?.message,
    code: err?.code,
    request: {
      url: config?.url,
      method: config?.method,
      params: deepRedact(config?.params),
      data: requestData,
    },
    response: {
      status: response?.status,
      data: responseData,
    },
  };
}
